import type { Game } from "../api/types";

export const MOCK_GAMES: Game[] = [
  {
    id: "g1",
    title: "Neon Abyss",
    developer: "Team17 Digital",
    genre: ["Action", "Roguelite"],
    platform: ["PC", "PS5", "Xbox"],
    price: 24.99,
    originalPrice: 39.99,
    rating: 4.5,
    reviewCount: 1842,
    tags: ["roguelite", "action", "pixel", "indie"],
    description:
      "Descend into the abyss in this frantic roguelite action-platformer. Combine ever-escalating guns and divine relics as you explore a neon-lit underworld ruled by warring gods. Every run is different — every death a lesson carved in neon light.",
    releaseDate: "2024-11-15",
    gradient: "linear-gradient(140deg,#1a0030 0%,#4d0099 55%,#8800ee 100%)",
    accentColor: "#bb44ff",
    isFeatured: true,
    isNew: true,
    isTopRated: false,
    screenshots: ["#1a0030", "#4d0099", "#8800ee"],
    storeLinks: { steam: true, playStore: true, appStore: true },
    iapItems: [
      { name: "Starter Pack", price: 4.99, icon: "🎁" },
      { name: "Premium Skin Bundle", price: 9.99, icon: "✨" },
    ],
    reviews: [
      { user: "PixelKnight", rating: 5, text: "Best roguelite I've played this year. The synergies are insane!", date: "2024-11-20" },
      { user: "DungeonsLvr", rating: 4, text: "Amazing gameplay, can get repetitive but always pulls you back.", date: "2024-11-18" },
    ],
  },
  {
    id: "g2",
    title: "Starfield Chronicles",
    developer: "Nebula Studios",
    genre: ["RPG", "Sci-Fi"],
    platform: ["PC", "PS5"],
    price: 59.99,
    originalPrice: 59.99,
    rating: 4.8,
    reviewCount: 5621,
    tags: ["rpg", "space", "exploration", "story-rich"],
    description:
      "Chart your own course across thousands of star systems in this epic space opera RPG. Every choice shapes the fate of the galaxy. Build your crew, pilot your ship, and uncover ancient cosmic secrets that predate humanity itself.",
    releaseDate: "2024-09-20",
    gradient: "linear-gradient(140deg,#000820 0%,#001650 55%,#002fa0 100%)",
    accentColor: "#4488ff",
    isFeatured: true,
    isNew: false,
    isTopRated: true,
    screenshots: ["#000820", "#001650", "#002fa0"],
    storeLinks: { steam: true, appStore: true },
    iapItems: [
      { name: "Galaxy Season Pass", price: 14.99, icon: "🌌" },
      { name: "Ship Cosmetics Bundle", price: 6.99, icon: "🚀" },
    ],
    reviews: [
      { user: "SpaceExplorer99", rating: 5, text: "The scale of this game is breathtaking. 200+ hours and still discovering new systems.", date: "2024-10-05" },
      { user: "RPGMaestro", rating: 5, text: "Best RPG of the decade, full stop.", date: "2024-09-28" },
    ],
  },
  {
    id: "g3",
    title: "Cyber Drift",
    developer: "Velocity Games",
    genre: ["Racing", "Action"],
    platform: ["PC", "PS5", "Xbox", "Mobile"],
    price: 0,
    originalPrice: 0,
    rating: 4.2,
    reviewCount: 9203,
    tags: ["racing", "cyberpunk", "free-to-play", "multiplayer"],
    description:
      "Race through neon-drenched megacities at breakneck speeds. Customize your rig down to the last LED strip and compete in brutal underground street races across a dystopian future Earth.",
    releaseDate: "2024-12-01",
    gradient: "linear-gradient(140deg,#001818 0%,#003535 55%,#007070 100%)",
    accentColor: "#00ffee",
    isFeatured: true,
    isNew: true,
    isTopRated: false,
    screenshots: ["#001818", "#003535", "#007070"],
    storeLinks: { steam: true, playStore: true },
    iapItems: [
      { name: "Turbo Kit", price: 2.99, icon: "🏎️" },
      { name: "Neon Pack", price: 7.99, icon: "💡" },
      { name: "Season Pass", price: 19.99, icon: "🎫" },
    ],
    reviews: [
      { user: "NightRacer", rating: 4, text: "F2P done right. Everything is earnable without spending.", date: "2024-12-10" },
      { user: "GearHead", rating: 4, text: "The physics engine is unmatched in any racing game.", date: "2024-12-08" },
    ],
  },
  {
    id: "g4",
    title: "Shadow Protocol",
    developer: "Phantom Works",
    genre: ["Stealth", "Thriller"],
    platform: ["PC", "PS5"],
    price: 44.99,
    originalPrice: 59.99,
    rating: 4.6,
    reviewCount: 3301,
    tags: ["stealth", "espionage", "thriller", "singleplayer"],
    description:
      "Infiltrate enemy installations and eliminate targets with surgical precision. Every mission is a layered puzzle — will you ghost through unseen or adapt when things go sideways?",
    releaseDate: "2024-08-05",
    gradient: "linear-gradient(140deg,#0a0a00 0%,#1e1e00 55%,#3a3a00 100%)",
    accentColor: "#ccdd00",
    isFeatured: false,
    isNew: false,
    isTopRated: true,
    screenshots: ["#0a0a00", "#1e1e00", "#3a3a00"],
    storeLinks: { steam: true, appStore: true, amazon: true },
    iapItems: [],
    reviews: [
      { user: "AgentX", rating: 5, text: "Makes Splinter Cell look outdated. Absolutely masterful stealth design.", date: "2024-08-20" },
      { user: "TacOps", rating: 4, text: "Hard but fair. The AI is genuinely smart.", date: "2024-08-15" },
    ],
  },
  {
    id: "g5",
    title: "Lost Meridian",
    developer: "Compass Interactive",
    genre: ["Adventure", "Puzzle"],
    platform: ["PC", "Mobile", "PS5"],
    price: 19.99,
    originalPrice: 19.99,
    rating: 4.7,
    reviewCount: 2105,
    tags: ["adventure", "puzzle", "story-rich", "atmospheric"],
    description:
      "Navigate a world where compasses point toward forgotten memories. Unravel the mystery of a lost civilization through stunning hand-crafted environments and mind-bending puzzles that reshape your understanding of the world.",
    releaseDate: "2024-10-10",
    gradient: "linear-gradient(140deg,#1a0d00 0%,#4a2400 55%,#8c4800 100%)",
    accentColor: "#ffaa44",
    isFeatured: false,
    isNew: false,
    isTopRated: true,
    screenshots: ["#1a0d00", "#4a2400", "#8c4800"],
    storeLinks: { steam: true, playStore: true, appStore: true },
    iapItems: [{ name: "Hint Pack (20)", price: 1.99, icon: "💡" }],
    reviews: [
      { user: "PuzzleMaster", rating: 5, text: "Gorgeous and thoughtful. Every puzzle feels hand-crafted with love.", date: "2024-10-20" },
      { user: "AdventureSeeker", rating: 4, text: "The story caught me completely off guard. Emotional ending.", date: "2024-10-18" },
    ],
  },
  {
    id: "g6",
    title: "Iron Legion",
    developer: "Stronghold Dev",
    genre: ["Strategy"],
    platform: ["PC"],
    price: 34.99,
    originalPrice: 49.99,
    rating: 4.3,
    reviewCount: 876,
    tags: ["strategy", "rts", "military", "historical"],
    description:
      "Command vast armies across sprawling battlefields. Build, research, and conquer in this deep real-time strategy experience set in an alternate mechanised Iron Age. Every decision shapes the fate of empires.",
    releaseDate: "2024-07-22",
    gradient: "linear-gradient(140deg,#1a0000 0%,#440000 55%,#770000 100%)",
    accentColor: "#ff6644",
    isFeatured: false,
    isNew: false,
    isTopRated: false,
    screenshots: ["#1a0000", "#440000", "#770000"],
    storeLinks: { steam: true },
    iapItems: [],
    reviews: [
      { user: "StrategyKing", rating: 4, text: "Deep mechanics and a surprisingly good campaign.", date: "2024-08-01" },
      { user: "WarbirdPC", rating: 4, text: "The best RTS since Starcraft II era.", date: "2024-07-30" },
    ],
  },
  {
    id: "g7",
    title: "Void Runner",
    developer: "ZeroG Studios",
    genre: ["Platformer", "Action"],
    platform: ["PC", "Mobile", "Xbox"],
    price: 14.99,
    originalPrice: 14.99,
    rating: 4.4,
    reviewCount: 4532,
    tags: ["platformer", "speedrun", "indie", "precision"],
    description:
      "Sprint through collapsing dimensions in this lightning-fast precision platformer. Defy physics, collect anomalies, and race against the void itself as reality tears apart around you.",
    releaseDate: "2024-11-28",
    gradient: "linear-gradient(140deg,#00003a 0%,#00007a 55%,#2200cc 100%)",
    accentColor: "#6644ff",
    isFeatured: false,
    isNew: true,
    isTopRated: false,
    screenshots: ["#00003a", "#00007a", "#2200cc"],
    storeLinks: { steam: true, playStore: true },
    iapItems: [{ name: "Cosmetic Bundle", price: 3.99, icon: "🎨" }],
    reviews: [
      { user: "Speedrunner", rating: 5, text: "Already clocked 80 hours. The movement system is pure perfection.", date: "2024-12-05" },
      { user: "IndieLvr", rating: 4, text: "Challenging but never unfair. A gem.", date: "2024-12-02" },
    ],
  },
  {
    id: "g8",
    title: "Dragon Siege",
    developer: "FireWyrm Games",
    genre: ["RPG", "Fantasy"],
    platform: ["PC", "PS5", "Xbox", "Mobile"],
    price: 0,
    originalPrice: 0,
    rating: 4.0,
    reviewCount: 12847,
    tags: ["rpg", "fantasy", "free-to-play", "multiplayer"],
    description:
      "Forge alliances, train legendary dragons, and lay siege to enemy fortresses in this massively multiplayer fantasy RPG. The realm needs a dragon lord — command yours to glory.",
    releaseDate: "2024-06-01",
    gradient: "linear-gradient(140deg,#0d1800 0%,#1e3a00 55%,#336600 100%)",
    accentColor: "#66dd00",
    isFeatured: false,
    isNew: false,
    isTopRated: false,
    screenshots: ["#0d1800", "#1e3a00", "#336600"],
    storeLinks: { steam: true, playStore: true, appStore: true },
    iapItems: [
      { name: "Dragon Egg", price: 4.99, icon: "🥚" },
      { name: "Gold Chest", price: 9.99, icon: "📦" },
      { name: "Dragon Pass", price: 24.99, icon: "🐉" },
    ],
    reviews: [
      { user: "DragonLord", rating: 4, text: "The guild system is incredibly deep. Great social game.", date: "2024-07-10" },
      { user: "FantasyNerd", rating: 4, text: "Surprisingly fair F2P model. Enjoying it immensely.", date: "2024-06-20" },
    ],
  },
  {
    id: "g9",
    title: "Arctic Storm",
    developer: "Frozen Peak Games",
    genre: ["Battle Royale", "Shooter"],
    platform: ["PC", "PS5", "Xbox", "Mobile"],
    price: 0,
    originalPrice: 0,
    rating: 3.9,
    reviewCount: 21034,
    tags: ["battle-royale", "shooter", "free-to-play", "multiplayer"],
    description:
      "Drop into a frozen apocalyptic tundra where 100 players fight for survival. Dynamic weather systems, destructible ice environments, and brutal close-quarters combat redefine the BR genre.",
    releaseDate: "2024-05-15",
    gradient: "linear-gradient(140deg,#001a2e 0%,#003355 55%,#005588 100%)",
    accentColor: "#44bbff",
    isFeatured: false,
    isNew: false,
    isTopRated: false,
    screenshots: ["#001a2e", "#003355", "#005588"],
    storeLinks: { steam: true, playStore: true, appStore: true },
    iapItems: [
      { name: "Battle Pass", price: 9.99, icon: "🎯" },
      { name: "Skin Bundle", price: 14.99, icon: "❄️" },
    ],
    reviews: [
      { user: "FPSGod", rating: 4, text: "The snow physics make every firefight feel different.", date: "2024-06-01" },
      { user: "BRAddict", rating: 3, text: "Good but needs more content updates.", date: "2024-05-25" },
    ],
  },
  {
    id: "g10",
    title: "Quantum Break: Origins",
    developer: "Paradox Frame",
    genre: ["Action", "Sci-Fi"],
    platform: ["PC", "PS5"],
    price: 29.99,
    originalPrice: 49.99,
    rating: 4.5,
    reviewCount: 3788,
    tags: ["sci-fi", "action", "story-rich", "singleplayer"],
    description:
      "Manipulate time to survive an unravelling reality. Fuse third-person shooter combat with time-stop powers in this cinematic thriller set across fractured timelines.",
    releaseDate: "2024-04-10",
    gradient: "linear-gradient(140deg,#001530 0%,#002a5a 55%,#004080 100%)",
    accentColor: "#00aaff",
    isFeatured: false,
    isNew: false,
    isTopRated: true,
    screenshots: ["#001530", "#002a5a", "#004080"],
    storeLinks: { steam: true, appStore: true },
    iapItems: [],
    reviews: [
      { user: "TimeKeeper", rating: 5, text: "The time manipulation mechanics are the most creative I've seen.", date: "2024-04-20" },
      { user: "CinematicFan", rating: 4, text: "Plays like an interactive blockbuster film. Loved it.", date: "2024-04-18" },
    ],
  },
];
